import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import ModalFooter from 'components/ModalFooter';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';

import InviteParticipantsSection from './InviteParticipantsSection';
import { ScheduleMeetingFormValues } from './types';
import { buildRoomUrl } from '../utils/getMeetingInviteUrl';

interface ScheduleMeetingStep2Props {
  messengerRoomId?: string;
  onBack: () => void;
  onCancel: () => void;
  onSubmit: () => void;
  isSubmitting?: boolean;
}

const ScheduleMeetingStep2 = ({
  messengerRoomId: _messengerRoomId,
  onBack,
  onCancel: _onCancel,
  onSubmit,
  isSubmitting,
}: ScheduleMeetingStep2Props) => {
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext<ScheduleMeetingFormValues>();
  const { workspaceId, workspacePermissions } = useWorkspacesContext();

  const slug = watch('slug');
  const slugPostfix = watch('slugPostfix');
  const isOrganisationMeeting = watch('isOrganisationMeeting');
  const participants = watch('participants');

  const meetingUrl = buildRoomUrl(`${slug}-${slugPostfix}`);

  return (
    <>
      <div className="flex flex-1 flex-col gap-4 min-h-0 overflow-y-auto px-4 py-4">
        <InviteParticipantsSection
          inviteInputMode={isOrganisationMeeting ? 'matrixIdOnly' : 'emailAndMatrixId'}
          participants={participants}
          onParticipantsChange={(next) => setValue('participants', next, { shouldValidate: true })}
          meetingUrl={meetingUrl}
          showOrganisationMeetingToggle={!!workspaceId && workspacePermissions.invitePeople}
          isOrganisationMeeting={!!isOrganisationMeeting}
          onOrganisationMeetingChange={(value) => setValue('isOrganisationMeeting', value, { shouldValidate: true })}
        />
      </div>

      <ModalFooter
        cancelText={t('schedule_meeting.back_button')}
        successButtonText={t('schedule_meeting.submit_button')}
        onCloseClick={onBack}
        onSubmit={onSubmit}
        isLoading={isSubmitting}
      />
    </>
  );
};

export default ScheduleMeetingStep2;
